import { Blockquote } from "@radix-ui/themes";

export default function ZHistoryBanner() {
  return (
    <>
      <Blockquote size="8" color>
        History
      </Blockquote>
    </>
  )
}
